import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { FlexColumn, FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import styled from "styled-components";

export const ViewByDomainChartWrapper = styled(FlexRow)`
    box-sizing: border-box;
    min-height: 313px;
`;

export const ChartWrapper = styled.div`
    flex: 1;
`;

export const LegendContainer = styled(FlexColumn)`
    box-sizing: border-box;
    padding: 0 24px;
    gap: 16px;
`;

export const Bullet = styled.div<{ color?: string }>`
    width: 10px;
    height: 10px;
    border-radius: 50%;
    box-sizing: border-box;
    background-color: ${({ color }) => color || colorsPalettes.carbon[0]};
`;

export const Label = styled.span`
    ${setFontVariant("dataTable1", colorsPalettes.carbon[400])};
    font-weight: 400;
`;
